import Axios from "axios";
import { baseUrl } from "app/utils/constants/paths";
import { setAuthToken } from "@jumbo/services/auth/jwtAuth";
Axios.defaults.baseURL = "";
Axios.defaults.headers.post["Content-Type"] = "application/json";

const axiosApiInstance = Axios.create();

// Request interceptor for API calls
axiosApiInstance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers["x-access-token"] = `${token}`;
      // config.headers["Content-Type"]="application/json";
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptor for API calls
axiosApiInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const originalRequest = error.config;
    if (!error.response || !originalRequest) {
      return Promise.reject(error);
    }
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem("refresh_token");

      return Axios.post(
        `${baseUrl}/auth/getaccesstoken`,
        { refresh_token: refreshToken },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then(({ data }) => {
          localStorage.setItem("access_token", data.access_token);
          localStorage.setItem("refresh_token", data.refresh_token);
          setAuthToken(data.access_token);
          return new Promise((resolve) => {
            resolve(axiosApiInstance(originalRequest));
          });
        })
        .catch((err) => {
          setAuthToken(null);
          localStorage.clear();
          window.location.href = "/login";
        });
    }

    return Promise.reject(error);
  }
);

export default axiosApiInstance;
